import { site } from '../content';

export default function Footer({ onContact }) {
  return (
    <footer
      id="footer"
      className="region section section-screen-h section-valign text-center theme"
      data-bg="var(--color-tertiary-b)"
      data-color="var(--color-tertiary-a)"
      data-highlight="var(--color-primary)"
      data-highlight-color="var(--color-tertiary-a)"
      data-start="late"
      data-header-fade="false"
    >
      <article className="section-inner-large section-inner-pad relative z-10">
        <div className="contain container container-xxl">
          <div className="flex flex-wrap justify-center">
            <div className="w-full md:w-5/6">
              <h1 className="display">{site.footer.title}</h1>
              <p className="intro">{site.footer.intro}</p>
              <p>{site.footer.body}</p>
              <div className="actions mt-4">
                <a
                  href="#contact"
                  className="btn btn-primary js-contact-trigger"
                  data-scroll-rate="2.0"
                  onClick={(event) => {
                    event.preventDefault();
                    onContact();
                  }}
                >
                  {site.footer.cta}
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
      <section id="base" className="container text-center">
        <div className="flex flex-wrap">
          <div className="w-full">
            <div id="legal">
              <p id="copyright">{site.footer.copyright}</p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}

export function Contact({ visible, intro }) {
  return (
    <section
      id="contact"
      className={`region section section-screen-h section-valign text-center theme${visible ? ' visible' : ''}`}
      data-bg="var(--color-tertiary-a)"
      data-color="var(--color-tertiary-b)"
      data-highlight="var(--color-primary)"
      data-highlight-color="var(--color-secondary)"
      data-header-fade="false"
    >
      <article className="section-inner-large section-inner-pad relative z-10">
        <div className="contain container-fluid container-limit">
          <div className="flex flex-wrap justify-center">
            <div className="w-full">
              <h1>{site.contact.title}</h1>
              <p className="intro">{intro || site.contact.intro}</p>
              <p>
                The best way to reach me is via{' '}
                <a href={site.linkedin} target="_blank" rel="noreferrer" className="link-linkedin">
                  LinkedIn
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
}
